import { motion } from "framer-motion";

import img1 from "../image/img1.png";

import { styles } from "../styles";
import { SectionWrapper } from "../hoc";

const Hero = () => {
  return (
    <div className="pt-32 flex flex-row items-start gap-8">
      <div className="flex flex-col justify-center items-center mt-5">
        <div className="w-5 h-5 rounded-full bg-[#915eff]" />
        <div className="w-1 sm:h-80 h-40 violet-gradient" />
      </div>
      <div>
        <h1 className={`${styles.heroHeadText} text-white`}>
          Hi, I'm <span className="text-[#915eff]">Jacek</span>
        </h1>

        <div className="flex flex-col sm:flex-row sm:gap-8 w-full items-start">
          <div className="w-full sm:w-1/2 mt-4 sm:mt-0 order-2 sm:order-1">
            <p className={`${styles.heroSubText} mt-2 text-white-100`}>
              I develop Java web applications.
            </p>
            <p className="text-white mt-2 text-justify">
              I am a former structural engineer and have been a backend developer for four years.
              Thanks to my unique background in civil engineering, I bring a fresh perspective to
              software development. I combine problem-solving skills honed in the building industry
              with a logic-driven approach, enjoying the process of breaking down programming
              challenges into smaller, manageable pieces. I am dedicated to finding optimal
              solutions and am eager to learn new technologies, tools, and approaches.
              <br />
              Currently, I am developing my TDD and DDD skills.
            </p>
          </div>
          <div className="w-full sm:w-1/2 sm:min-w-[300px] order-1 sm:order-2">
            <img src={img1} alt="Your Image" className="w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionWrapper(Hero);
